// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Dialog structure matching well-attachments-dialog ── */
mat-dialog-content {
  min-width: 700px;
  min-height: 200px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
  max-height: 72vh;
  overflow-y: auto;
}

.content {
  padding: 16px;
  padding-bottom: 50px;
  border-radius: 4px;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap {
  gap: 12px;
}

/* ── Date fields: label + input side by side, two pairs in a row ── */
.form-row {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}

.form-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-group .form-label {
  font-size: medium;
  white-space: nowrap;
  margin: 0;
  color: #000;
  font-family: 'GothamNarrowBook';
}

.form-control {
  font-family: 'GothamNarrowBook';
  color: #6B6D6F;
  width: 150px;
}

/* ── Notes: label left-aligned with textarea ── */
.notes-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.notes-row .form-label {
  padding-top: 6px;
  white-space: nowrap;
  margin: 0;
  font-family: 'GothamNarrowBook';
  font-size: medium;
  color: #000;
}

.notes-textarea {
  resize: vertical;
  flex: 1;
  font-family: 'GothamNarrowBook';
}

/* ── Mix section ── */
.mix-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.mix-title {
  font-family: 'GothamNarrowBold';
  font-weight: bold;
  color: #000;
}

.btn-remove {
  background: none;
  border: none;
  color: #E21836;
  font-size: 16px;
  font-family: 'GothamBold';
  font-weight: bolder;
  line-height: 1;
  cursor: pointer;
  padding: 0 2px;
}

.btn-remove:hover { 
  color: #97002E; 
}

/* ── Two-column tests checkbox grid ── */
.tests-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 32px;
  margin-bottom: 12px;
  font-family: 'GothamNarrowBook';
  color: #000;
}

/* NextPage .branded handles checkbox + label appearance */
/* Force square checkboxes — override any border-radius from NextPage/browser */
.tests-grid input[type="checkbox"] {
  border-radius: 0 !important;
  -webkit-border-radius: 0 !important;
  appearance: none;
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  border: 1px solid #6B6D6F;
  background-color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
  top: 2px;
}

.tests-grid input[type="checkbox"]:checked {
  background-color: #0066B2;
  border-color: #0066B2;
}

.tests-grid input[type="checkbox"]:checked::after {
  content: '';
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: 2px solid #fff;
  border-top: none;
  border-left: none;
  transform: rotate(45deg);
}

/* ── Inline mix picker row (dropdown + Ok + Cancel) ── */
.mix-picker-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mix-picker-row select.auto-size {
  min-width: 150px;
  font-family: 'GothamNarrowBook';
}

/* ── Material dialog surface → white ── */
::ng-deep .mat-mdc-dialog-surface,
::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  background-color: #fff !important;
}

.form-control {
  font-family: 'GothamNarrowBook';
  color: #6B6D6F;
}

.text-muted {
  font-family: 'GothamNarrowBook';
  color: #6B6D6F;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/cooperative-test-request/cooperative-test-request.component.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;AACb;;AAEA,0DAA0D;AAC1D,+EAA+E;AAC/E;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,0CAA0C;AAC1C;;EAEE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB","sourcesContent":["/* ── Dialog structure matching well-attachments-dialog ── */\nmat-dialog-content {\n  min-width: 700px;\n  min-height: 200px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n  max-height: 72vh;\n  overflow-y: auto;\n}\n\n.content {\n  padding: 16px;\n  padding-bottom: 50px;\n  border-radius: 4px;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n/* ── Date fields: label + input side by side, two pairs in a row ── */\n.form-row {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.form-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.form-group .form-label {\n  font-size: medium;\n  white-space: nowrap;\n  margin: 0;\n  color: #000;\n  font-family: 'GothamNarrowBook';\n}\n\n.form-control {\n  font-family: 'GothamNarrowBook';\n  color: #6B6D6F;\n  width: 150px;\n}\n\n/* ── Notes: label left-aligned with textarea ── */\n.notes-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.notes-row .form-label {\n  padding-top: 6px;\n  white-space: nowrap;\n  margin: 0;\n  font-family: 'GothamNarrowBook';\n  font-size: medium;\n  color: #000;\n}\n\n.notes-textarea {\n  resize: vertical;\n  flex: 1;\n  font-family: 'GothamNarrowBook';\n}\n\n/* ── Mix section ── */\n.mix-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.mix-title {\n  font-family: 'GothamNarrowBold';\n  font-weight: bold;\n  color: #000;\n}\n\n.btn-remove {\n  background: none;\n  border: none;\n  color: #E21836;\n  font-size: 16px;\n  font-family: 'GothamBold';\n  font-weight: bolder;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 2px;\n}\n\n.btn-remove:hover { \n  color: #97002E; \n}\n\n/* ── Two-column tests checkbox grid ── */\n.tests-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0 32px;\n  margin-bottom: 12px;\n  font-family: 'GothamNarrowBook';\n  color: #000;\n}\n\n/* NextPage .branded handles checkbox + label appearance */\n/* Force square checkboxes — override any border-radius from NextPage/browser */\n.tests-grid input[type=\"checkbox\"] {\n  border-radius: 0 !important;\n  -webkit-border-radius: 0 !important;\n  appearance: none;\n  -webkit-appearance: none;\n  width: 14px;\n  height: 14px;\n  border: 1px solid #6B6D6F;\n  background-color: #fff;\n  cursor: pointer;\n  flex-shrink: 0;\n  position: relative;\n  top: 2px;\n}\n\n.tests-grid input[type=\"checkbox\"]:checked {\n  background-color: #0066B2;\n  border-color: #0066B2;\n}\n\n.tests-grid input[type=\"checkbox\"]:checked::after {\n  content: '';\n  position: absolute;\n  left: 4px;\n  top: 1px;\n  width: 4px;\n  height: 8px;\n  border: 2px solid #fff;\n  border-top: none;\n  border-left: none;\n  transform: rotate(45deg);\n}\n\n/* ── Inline mix picker row (dropdown + Ok + Cancel) ── */\n.mix-picker-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mix-picker-row select.auto-size {\n  min-width: 150px;\n  font-family: 'GothamNarrowBook';\n}\n\n/* ── Material dialog surface → white ── */\n::ng-deep .mat-mdc-dialog-surface,\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  background-color: #fff !important;\n}\n\n.form-control {\n  font-family: 'GothamNarrowBook';\n  color: #6B6D6F;\n}\n\n.text-muted {\n  font-family: 'GothamNarrowBook';\n  color: #6B6D6F;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
